























































































































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

import { Solitaire } from "@/common/interface/solitaire_type";

const Locked = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571311741320.png?x-oss-process=image/resize,w_300,limit_0';
const UnLocked = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571311752337.png?x-oss-process=image/resize,w_300,limit_0';
const RunMan = require("@/assets/img/run.gif");

const SPEED = 0.25;

@Component
export default class SolitaireProgress extends Vue {
  @Getter('solitaireList') solitaireList!: Array<Solitaire>
  @Getter("section") section!: any;
  @Getter("titleSection") titleSection!: any;
  @Getter("numberSection") numberSection!: any;
  @Getter("joinNumber") joinNumber!: number;
  @Getter("hasPaidNumber") hasPaidNumber!: number;
  @Getter('leftQuota') leftQuota!: number;
  @Getter('limitNum') limitNum!: number;
  @Getter('canPay') canPay!: boolean;
  @Getter("showJoinFooter") showJoinFooter!: boolean;
  @Getter("showNum") showNum!: boolean;
  
  UnLocked: string = UnLocked;
  Locked:string = Locked;
  RunMan: string = RunMan;

  getbackgroundImg(solitaire: Solitaire) {
    if (this.number >= solitaire.size) {
      if (solitaire.reward) {
        return this.section.unLockedLarge
      } else {
        return this.section.unLockedSmall
      }
    } else {
      if (solitaire.reward) {
        return this.section.lockedLarge
      } else {
        return this.section.lockedSmall
      }
    }
  }
  get number() {
    return this.canPay ? this.hasPaidNumber : this.joinNumber;
  }
  get progress() {
    const len = this.solitaireList.length + 1;
    const availableLen = this.availableSolitaireList.length;
    let leftProgress = 0;
    if (this.rencentSolitaire) {
      const molecule = this.rencentSolitaire.size - this.currentSize;
      const denominator =  this.number -this.currentSize;
      leftProgress = molecule ? denominator / molecule / len : 0;
    } else {
      const molecule = this.limitNum -this.currentSize;
      const denominator = this.number -this.currentSize;
      leftProgress = molecule ? denominator / molecule / len : 0;
    }
    return (availableLen / len + leftProgress) * 100;
   
  }
  get recentProgress() {
    const len = this.solitaireList.length + 1;
    const recentLen = this.availableSolitaireList.length + 1;
    return (recentLen / len * 100 - 3);
  }
  
  get currentSize() {
    const len = this.availableSolitaireList.length;
    return len ? Number(this.availableSolitaireList[len - 1].size) : 0
  }

  get currentPirce() {
    const len = this.availableSolitaireList.length;
    return len ? Number(this.availableSolitaireList[len - 1].price) : 0
  }

  get availableSolitaireList() : Array<Solitaire>{
    // 已经达到的某些阶段
    const availableSolitaireList = this.solitaireList.filter(solitaire => this.number >= solitaire.size)
    return availableSolitaireList;
  }

  get rencentSolitaire(): any{
    // 还未达到的下一个阶梯
    const rencentSolitaire = this.solitaireList.find(solitaire => solitaire.size > this.number);
    return rencentSolitaire;
  }

  mounted() {
    const style = document.createElement('style');
    document.head.appendChild(style);
    const width = window.innerWidth;
    const from = `from { left: 0}`;
    const to = `to { left: ${this.progress}% }`;
    (style.sheet as any).insertRule(`@-webkit-keyframes runMan { ${from} ${to} }`);
    const runMan = document.getElementsByClassName('run-man')[0];
    (runMan as any).style.animationDuration = `${this.progress / SPEED /100}s`;
  }
}
